import { api } from "lwc";
import Button from "tds/button";

export default class extends Button {
  @api href: string | null = null;
  @api rel: string | null = null;
  @api target: "_self" | "_blank" | "_parent" | "_top" | null = null;
}
